export const SUNO_NON_CUSTOM_PROMPT_MAX_CHARACTERS = 500

type AiActionPrompt = {
    tag?: string | null
    action_tag?: string | null
    prompt?: string | null
    inputs?: {
        text?: {
            value?: string | null
        } | null
    } | null
    settings?: {
        lyrics?: string | null
    } | null
}

const normalizedActionTag = (tag: string | null | undefined) =>
    String(tag || '')
        .trim()
        .replace(/^!+/, '')
        .toLowerCase()

export function promptCharacterLimitForAiAction(
    tag: string | null | undefined,
    lyrics: string | null | undefined,
) {
    if (normalizedActionTag(tag) !== 'suno' || String(lyrics || '').trim()) return null

    return SUNO_NON_CUSTOM_PROMPT_MAX_CHARACTERS
}

export function aiActionPromptValidationMessage(action: AiActionPrompt) {
    const characterLimit = promptCharacterLimitForAiAction(
        action.tag || action.action_tag,
        action.settings?.lyrics,
    )
    if (!characterLimit) return null

    const prompt = String(action.inputs?.text?.value || action.prompt || '').trim()
    if (prompt.length <= characterLimit) return null

    return `Suno prompts are limited to ${characterLimit} characters unless custom lyrics are added.`
}
